/*
 * @Autor: 杨华
 * @Version: 1.0
 * @Date: 2019-11-26 15:16:55
 * @LastEditors: xx
 * @Description:
 * @LastEditTime: 2021-09-22 16:44:08
 */
import { objAny } from "../common/common-interface";
let configData = {
  loginUrl: null,
  // ajaxHost: "/api/serv", // 接口公用的一段
  ajaxHost: process.env.VUE_APP_BASE_API, // 接口公用的一段
  apiStatus: 0,
  host: "",
  footText: "CS Enegy",
  formSize: "default", // 全局按钮表单的大小
  pickerOptions: {
    disabledDate(time: objAny) {
      return (
        time.getTime() > new Date(new Date().toLocaleDateString()).getTime()
      );
    }
  },
  pickerOptionsMin: {
    disabledDate(time: objAny) {
      return (
        time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
      );
    }
  },
  draggable: false, // 弹出框是否可以拖动
  mapKeyApi: "38963cf6e1d7092a3dfcf940b4979bd5",
  // echartsJS: "http://oper.oms-test.smartpevc.com/static/common/echarts.min.js",
  fileImg: process.env.VUE_APP_BASE_FILE, // 图片路径要加上这一段才能显示出来
  sysModulePkId: "1", // 系统管理的菜单Id
  footerUrl: "https://beian.miit.gov.cn",
  powerObj: {
    // 权限对应的code,在页面里面直接用 xx.query 来做按钮权限,权限直接加入到 $route.meat 里面的 privilegeVoList
    "100501": "query",
    "100503": "updata",
    "100504": "delete",
    "100508": "export",
    "100502": "add"
  },
  tableStripe: true,
  socketServer: "",
  tioConfig: {
    ws_protocol: process.env.NODE_ENV == "development" ? "ws" : "wss",
    ip: process.env.VUE_APP_BASE_IP,
    // ip: "47.115.147.82",
    port: "9876",
    heartbeatTimeout: 5000, //心跳时间 单位：毫秒
    reconnInterval: 1000, // 重连间隔时间 单位：毫秒
    binaryType: "arraybuffer" // 'blob' or 'arraybuffer';//arraybuffer是字节
  },
  languageShow: true
};
//为了防止哪天在域名中间加了东西 或者接口域名变了 ，然后外面连接一个js 文件 js 文件里放这几个参数就可以了
// 其它打包路径已设置为相对路径 ,只和 static  和 index.html 文件 在同一层级就可以了
const win: objAny = window;
if (win.appConfig && typeof win.appConfig == "object") {
  configData = Object.assign(configData, win.appConfig);
}
export default configData;
